import { useIdleSession } from '../hooks/useIdleSession';
import { formatCountdown } from '../lib/inactivity';
import { colors } from '../styles/theme';
import Modal from './Modal';

/**
 * Mounted once for every signed-in screen. Silent while the person is active; two minutes
 * before the inactivity limit it asks whether they are still there, and at the limit the
 * session is ended and the sign-in page says why.
 */
const IdleSession = (): JSX.Element | null => {
  const { secondsLeft, stay } = useIdleSession();
  if (secondsLeft === null) return null;
  return (
    <Modal open onClose={stay} maxWidth="sm">
      <h2 className="text-lg font-semibold mb-1" style={{ color: colors.ink }}>
        Are you still there?
      </h2>
      <p className="text-sm mb-2" style={{ color: colors.inkSoft }}>
        You will be signed out for inactivity in
      </p>
      <p className="text-3xl font-semibold mb-5" style={{ color: colors.ink }} translate="no">
        {formatCountdown(secondsLeft)}
      </p>
      <div className="flex justify-end">
        <button
          type="button"
          onClick={stay}
          className="px-4 py-2 rounded-lg text-sm font-semibold"
          style={{ background: colors.navy, color: '#FFFFFF' }}
        >
          Stay signed in
        </button>
      </div>
    </Modal>
  );
};

export default IdleSession;
